(function($){
    $('.page-calc .fill').on('click', function(e){
        e.preventDefault();
        if($('.inquiry').is(':visible')){
            $('.insurance-questions input[type="radio"]').each(function(){
                if($(this).attr('data-lock') != 1){
                    $(this).click();
                }
            })
            $('.insurance-questions .submit button').click();
        }
        if($('.order-form').is(':visible')){
            $('[name="vehicle-plate"]').val('PPP-1111');
            $('[name="register-date"]').val('2023-12-12');
            $('[name="brand"]').val('BMW').trigger('change');
            setTimeout(function(){
                $('[name="model"]').val('316');
            }, 1000)
            $('[name="make_year"]').val('2023');
            $('[name="power"]').val('200');
            $('[name="vin"]').val('kdnsiunczb362c8hy2');
            $('[name="invoice-date"]').val('2024-03-12');
            $('[name="vehicle-value"]').val('30000').trigger('change');
            $('[name="oc-insurance-date"]').val('2024-03-12');
            $('[name="oc-insurance-number"]').val('ocnumber');
            $('[name="oc-insurance-amount"]').val('30000').trigger('change');
            $('[name="client-name"]').val('Sebastian');
            $('[name="client-surname"]').val('Drewniak');
            $('[name="client-nip"]').val('090000045');
            $('[name="client-postcode"]').val('333 12');
            $('[name="client-city"]').val('Jonkowo');
            $('[name="client-street"]').val('Błękitna 29');
            $('[name="client-phone"]').val('+301234567890');
            $('[name="client-email"]').val('sebastian.drewniak@gmail.com');
            $('.single-agreement').each(function(){
                $(this).find('input').prop('checked', true);
            });
            setTimeout(function(){
                $('.order-form .submit button').click();
            }, 1200)
        }
    })
})(jQuery)